<template>
  <div class="signer-color-chip" />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SignerColorChip',
  props: {
    color: {
      type: String,
      required: true,
    },
  },
  computed: {
    bgColor () {
      return `rgb(var(--v-theme-surface-${this.color}))`
    },
  },
})
</script>

<style scoped lang="scss">
  @import "@/scss/border-tokens";

  .signer-color-chip {
    display: inline-block;
    width: 12px;
    height: 12px;
    @include border-radius('border-radius-2');
    background-color: v-bind(bgColor);
  }
</style>
